<template>
  <div class="flex column" style="max-width: 420px; min-width: 140px" v-if="!$store.state.auth.uid">
    <form class="flex vertical md-font" @submit.prevent="
      $store.state.userExists
        ? handleLogin(particulars, 'email')
        : handleCreate(particulars, 'create')
      ">
      <div v-if="
        $store.state.app.advanced.roles &&
        $store.state.app.advanced.roles.user
      ">
        <div v-for="(req, reqkey) in $store.state.app.advanced.roles.user
          .requirements" class="b8 p4" :key="reqkey">
          <div v-if="req.validations && particulars.requirements">
            Confirm the following to proceed with user registration:
            <label class="flex align-center xs-font" v-for="(validation, validationi) in req.validations"
              :key="validationi">
              <b>{{ validationi + 1 }}. </b>
              <input @change="validate(reqkey, validation)" type="checkbox" v-if="validation.type === 'boolean'"
                v-model="particulars.requirements[reqkey][validation.value]" />
              <div class="container p4 m4" v-if="validation.type === 'select'">
                <span v-for="option in validation.options" :key="option">
                  <span v-if="particulars.requirements" class="m4" :class="particulars.requirements[reqkey][
                    validation.value
                  ].indexOf(option) > -1
                    ? 'update'
                    : ''
                    " @click="
                      particulars.requirements[reqkey][
                        validation.value
                      ].indexOf(option) > -1
                        ? particulars.requirements[reqkey][
                          validation.value
                        ].splice(
                          particulars.requirements[reqkey][
                            validation.value
                          ].indexOf(option),
                          1
                        )
                        : particulars.requirements[reqkey][
                          validation.value
                        ].push(option);
                    validate(reqkey, validation);
                    ">{{ option }}</span>
                </span>
              </div>
              <b :class="(validation.type !== 'select' &&
                particulars.requirements[reqkey][validation.value]) ||
                particulars.requirements[reqkey][validation.value].length > 0
                ? ''
                : 'warn-text'
                ">{{ validation.value }}</b>
              <input @change="validate(reqkey, validation)" v-if="
                validation.type === 'text' || validation.type === 'number'
              " :type="validation.type" :value="validation.value"
                v-model="particulars.requirements[reqkey][validation.value]" />
            </label>
          </div>
        </div>
      </div>
      <div class="flex align-center">
        <div class="">
          <div class="flex column update p4">
            <b v-if="!show.emaillogin" class="update center sm-font">Log in</b>
            <b v-else @click="show.emaillogin = false; particulars.password = ''; particulars.email = ''"
              class="r16 sm-font flex align-center">
              <i class="fa fa-chevron-left r4"></i>cancel</b>
            <div class="flex flexy p4 align-center">
              <span v-if="!particulars.email && !nosocial && !show.emaillogin">
                <a class="flex align-center update " href :key="pKey" v-for="(provider, pKey) in ['google']"
                  @click.prevent="handleLogin({ provider }, 'social')">
                  <i :class="`update r4 fab fa-${provider}`"></i> Google
                </a>
              </span>
              <span v-if="!show.emaillogin" class="xs-font p4 flex">or</span>
              <div class="flex">
                <a v-if="!show.emaillogin" class="flex align-center update" @click="show.emaillogin = !show.emaillogin">
                  <i :class="`fa fas r4 fa-envelope`"></i>
                  <span>Email</span></a>
                <div class="flex flexy fill">
                  <div class="flex column" v-if="show.emaillogin">
                    <input v-debounce="delay" v-model.lazy="particulars.email" type="email" autofocus
                      placeholder="Log in with e-mail" class="p8 md-input flexy" />
                    <input v-if="$store.state.isEmail" v-model="particulars.password" type="password"
                      placeholder="Password" class="p8 t4 flexy" />
                    <code class="xs-font label warn p4 t4"
                      v-if="$store.state.isEmail && particulars.password.length <= 7">Password >= 8 symbols</code>
                  </div>
                  <button v-if="particulars.email && $store.state.isEmail && show.emaillogin" :disabled="disabled ||
                    JSON.stringify(required).indexOf('false') > -1 ||
                    particulars.password.length < 8
                    " class="l4 p16 update" type="submit">
                    <div v-if="$store.state.userExists" class="sm-font update"><i
                        class="fa fa-sign-in-alt flexy r4"></i>Log in</div>
                    <div v-else class="sm-font update"><i class="fa fa-user-plus flexy r4"></i>Create</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="$store.state.isEmail && $store.state.userExists" class="flex between wrap xs-font t8 white">
        <a href @click.prevent="magiclink(particulars)">Magic Link</a>
        <a href @click.prevent="handleReset(particulars)">Reset Password</a>
      </div>
    </form>
  </div>
  <div v-else>
    <b class="p8">
      <i :class="show.logout ? 'warn-text' : 'indicate-text'" @click="$set(show, 'logout', !show.logout)"
        class="fas fa-power-off" />
      <a class="l4 border-bottom" v-if="show.logout" @click="$store.dispatch('auth', { type: 'logout' })">Log out</a>
    </b>
  </div>
</template>

<script>
import debounce from "v-debounce";
export default {
  name: "auth",
  directives: { debounce },
  data() {
    return {
      required: {},
      delay: 150,
      disabled: false,
      msg: "auth Component Engaged",
      newAccount: "true",
      particulars: {
        email: "",
        password: "",
        requirements: {},
      },
      show: {
        emaillogin: false
      },
      showError: false,
    };
  },
  methods: {
    handleCreate(particulars, type) {
      let state = this.$store.state,
        adv = state.app.advanced;
      setTimeout(() => {
        if (state.userExists) {
          return this.handleLogin(particulars, type);
        } else {
          particulars.type = type;
          this.$store.dispatch("auth", particulars).then(() => {
            if (adv.roles.user.hooks) {
              let hook = adv.roles.user.hooks;
              // let name = hook.fun ? hook.fun.name : hook.get.name;
              this.$store.dispatch("run", {
                fun: hook.fun,
                payload: hook.getpayload || hook.payload || {},
              });
            }
          });
        }
      }, 250);
    },
    handleReset(particulars) {
      particulars.type = "reset";
      this.$store.dispatch("auth", particulars).then(() => {
        alert("Check your email to reset your password.");
      });
    },
    handleLogin(particulars, type) {
      particulars.type = type;
      this.$store.dispatch("auth", particulars);
    },
    magiclink(particulars) {
      particulars.type = "magiclink";
      this.$store.dispatch("auth", particulars).then(() => {
        alert("Check your email for the magic link.");
      });
    },
    validate(reqkey, validation) {
      let valid = this.particulars.requirements[reqkey][validation.value];
      this.$set(
        this.required,
        reqkey + validation.value,
        valid.length > 0 || valid !== false ? true : false
      );
    },
  },
  props: { nosocial: { type: String } },
  created: function () {
    // Check if routed from password change
    let valuemap = {
      select: [],
      boolean: false,
      text: "",
      number: 0,
    };
    if (window.location.href.includes("?email=")) {
      this.particulars.email = decodeURIComponent(
        window.location.href.split("?email=")[1]
      );
    }

    this.$store.state.app.advanced.roles &&
      this.$store.state.app.advanced.roles.user &&
      this.$store.state.app.advanced.roles.user.requirements
      ? Object.keys(this.$store.state.app.advanced.roles.user.requirements).map(
        (x) => {
          this.$set(this.particulars.requirements, x, {});
          this.$store.state.app.advanced.roles.user.requirements[
            x
          ].validations.map((y) => {
            this.$set(this.required, x + y.value, false);
            this.$set(
              this.particulars.requirements[x],
              y.value,
              valuemap[y.type]
            );
          });
        }
      )
      : null;
  },
  watch: {
    "particulars.email": {
      handler: function (val) {
        // disables button, checks if user is in the system
        this.disabled = true;
        this.$store.state.isEmail = false;
        this.$store.state.userExists = false;
        var re = /\S+@\S+\.\S+/;
        return re.test(val)
          ? this.$store
            .dispatch("auth", {
              email: val,
              type: "usercheck",
            })
            .then(() => {
              this.disabled = false;
            })
          : null;
      },
      immediate: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.between {
  justify-content: space-between;
}

.vertical {
  flex-direction: column;
}
</style>